// app/javascript/modules/modal_form.js
// Modal-based form system: intercepts new/edit links, loads form via AJAX,
// displays in modal, submits via AJAX — no page navigation needed.

var isLoading = false;

function getOverlay() { return document.getElementById('form-modal-overlay'); }
function getTitleEl() { return document.getElementById('form-modal-title'); }
function getBodyEl() { return document.getElementById('form-modal-body'); }
function getCloseBtn() { return document.getElementById('form-modal-close'); }

// --- Modal open/close ---
function openModal() {
  var overlay = getOverlay();
  if (!overlay) return;
  overlay.classList.add('modal-open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  var overlay = getOverlay();
  var titleEl = getTitleEl();
  var bodyEl = getBodyEl();
  if (overlay) overlay.classList.remove('modal-open');
  document.body.style.overflow = '';
  if (bodyEl) bodyEl.innerHTML = '';
  if (titleEl) titleEl.textContent = '';
  isLoading = false;
}

function showLoading() {
  var bodyEl = getBodyEl();
  if (bodyEl) {
    bodyEl.innerHTML =
      '<div class="flex items-center justify-center py-16">' +
      '<div class="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent"></div>' +
      '</div>';
  }
}

function showToast(message, type) {
  var toast = document.createElement('div');
  toast.className = 'form-modal-toast' + (type === 'error' ? ' toast-error' : '');
  toast.textContent = message;
  document.body.appendChild(toast);
  requestAnimationFrame(function() {
    toast.classList.add('toast-show');
  });
  setTimeout(function() {
    toast.classList.remove('toast-show');
    setTimeout(function() {
      if (toast.parentNode) toast.remove();
    }, 300);
  }, 2500);
}

// --- Conditional fields (data-show-when-select) ---
function initConditionalFields(container) {
  var fields = container.querySelectorAll('[data-show-when-select]');
  fields.forEach(function(field) {
    var parts = field.getAttribute('data-show-when-select').split(':');
    var selectId = parts[0];
    var showValue = parts[1];
    var select = container.querySelector('#' + selectId);
    if (!select) return;

    function toggle() {
      field.style.display = select.value === showValue ? '' : 'none';
    }

    select.removeEventListener('change', field._toggleFn);
    field._toggleFn = toggle;
    select.addEventListener('change', toggle);
    toggle();
  });
}

// --- Handle cancel links ---
function handleCancelLinks(container) {
  var cancelLinks = container.querySelectorAll('[data-modal-cancel], .btn-pearl-capsule');
  cancelLinks.forEach(function(link) {
    if (link.dataset.bound === 'true') return;
    link.dataset.bound = 'true';
    link.addEventListener('click', function(e) {
      e.preventDefault();
      closeModal();
    });
  });
}

// --- Handle form submission via AJAX ---
function handleFormSubmit(form) {
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    e.stopPropagation();

    var submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
    var originalText = '';
    var isInput = false;

    if (submitBtn) {
      isInput = submitBtn.tagName === 'INPUT';
      originalText = isInput ? submitBtn.value : submitBtn.textContent;
      if (isInput) {
        submitBtn.value = '提交中...';
      } else {
        submitBtn.textContent = '提交中...';
      }
      submitBtn.disabled = true;
      submitBtn.classList.add('opacity-60', 'cursor-not-allowed');
    }

    try {
      var formData = new FormData(form);
      var method = form.getAttribute('method') || 'POST';

      var response = await fetch(form.action, {
        method: method.toUpperCase() === 'GET' ? 'GET' : 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        redirect: 'follow'
      });

      // Detect success: either explicitly redirected (standard Rails pattern)
      // or the final URL differs from the form action (redirect was followed
      // but response.redirected may not be set in all browsers)
      var finalUrl = response.url;
      var isRedirected = response.redirected || (finalUrl !== form.action && response.ok);

      if (isRedirected) {
        // Success — server redirected to index page
        closeModal();
        showToast('操作成功');

        if (typeof Turbolinks !== 'undefined') {
          Turbolinks.visit(window.location.href);
        } else {
          window.location.reload();
        }
      } else {
        // Not redirected — could be validation errors or unexpected response
        var html = await response.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newForm = doc.querySelector('form');
        var bodyEl = getBodyEl();

        if (newForm && newForm.action === form.action) {
          // Validation errors — same form returned with error messages
          form.innerHTML = newForm.innerHTML;
          initConditionalFields(form);
          handleCancelLinks(form);
          if (bodyEl) bodyEl.scrollTop = 0;
        } else {
          // Unexpected response — reload current page.
          // NEVER visit response.url: for edit forms, response.url is the
          // form action URL (e.g. /admin/scenics/1/guide_points/1), which
          // is the :show route. Resources like guide_points, exhibition_halls,
          // and artifacts don't define :show, causing ActionController::RoutingError.
          closeModal();
          if (response.ok) {
            showToast('操作成功');
          } else {
            showToast('操作异常，请重试', 'error');
          }
          if (typeof Turbolinks !== 'undefined') {
            Turbolinks.visit(window.location.href);
          } else {
            window.location.reload();
          }
        }
      }
    } catch (err) {
      console.error('Form submit error:', err);
      showToast('提交失败，请重试', 'error');

      if (submitBtn) {
        if (isInput) {
          submitBtn.value = originalText;
        } else {
          submitBtn.textContent = originalText;
        }
        submitBtn.disabled = false;
        submitBtn.classList.remove('opacity-60', 'cursor-not-allowed');
      }
    }
  });
}

// --- Load form via AJAX ---
async function loadForm(url, title) {
  if (isLoading) return;
  isLoading = true;

  var titleEl = getTitleEl();
  if (titleEl && title) titleEl.textContent = title;
  showLoading();
  openModal();

  try {
    var response = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });
    var html = await response.text();
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    if (!title) {
      var pageTitle = doc.querySelector('.page-title, .page-header-title');
      if (pageTitle) {
        title = pageTitle.textContent.trim();
      } else {
        title = '编辑';
      }
    }
    titleEl = getTitleEl();
    if (titleEl) titleEl.textContent = title;

    var form = doc.querySelector('form');
    var bodyEl = getBodyEl();
    if (!form) {
      if (bodyEl) {
        bodyEl.innerHTML =
          '<div class="text-center py-12 text-text-secondary">' +
          '<p class="text-sm">表单加载失败</p>' +
          '<p class="text-xs mt-2">请刷新页面后重试</p>' +
          '</div>';
      }
      isLoading = false;
      return;
    }

    var backLinks = form.querySelectorAll('.btn-pearl-capsule[href]');
    backLinks.forEach(function(link) {
      link.setAttribute('href', '#');
      link.setAttribute('data-modal-cancel', 'true');
    });

    if (bodyEl) {
      bodyEl.innerHTML = '';
      bodyEl.appendChild(form);
    }

    initConditionalFields(form);
    handleCancelLinks(form);
    handleFormSubmit(form);

  } catch (err) {
    console.error('Modal form load error:', err);
    var bodyEl = getBodyEl();
    if (bodyEl) {
      bodyEl.innerHTML =
        '<div class="text-center py-12 text-text-secondary">' +
        '<p class="text-sm">加载失败，请重试</p>' +
        '</div>';
    }
  }

  isLoading = false;
}

// --- ESC to close ---
function handleEsc(e) {
  var overlay = getOverlay();
  if (e.key === 'Escape' && overlay && overlay.classList.contains('modal-open')) {
    closeModal();
  }
}

function initModalForm() {
  var overlay = getOverlay();
  if (!overlay) return;

  var closeBtn = getCloseBtn();

  // --- Close button ---
  if (closeBtn && closeBtn.dataset.modalBound !== 'true') {
    closeBtn.dataset.modalBound = 'true';
    closeBtn.addEventListener('click', closeModal);
  }

  // --- Click overlay to close ---
  if (overlay.dataset.modalBound !== 'true') {
    overlay.dataset.modalBound = 'true';
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
  }
}

// --- Intercept clicks on [data-modal-form] (event delegation, bound once) ---
if (!document._modalFormClickBound) {
  document._modalFormClickBound = true;
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-modal-form]');
    if (!link) return;
    e.preventDefault();
    var url = link.getAttribute('href');
    var title = link.getAttribute('data-modal-title') || '';
    loadForm(url, title);
  });

  document.addEventListener('keydown', handleEsc);
}

document.addEventListener('turbolinks:load', initModalForm);
